<template lang="pug">
include ../Bemto
+b.cabinet
  cabinet-admin(
    v-if="role === 'admin'"
  )
  cabinet-client(
    v-if="role === 'client'"
  )
  cabinet-talent(
    v-if="role === 'talent'"
  )
  welcome-modal
  success-payment
</template>

<script>

/* eslint-disable import/order */
import ChatBotModal from '@app/modals/ChatBotModal'
import WelcomeModal from '@app/modals/WelcomeModal';
import { mapActions, mapState } from 'vuex';
import SubscriptionPay from '@app/modals/SubscriptionPay'
import TalentLayout from './lk-talent/TalentLayout'
import ClientLayout from './lk-client/ClientLayout.vue'
import AdminLayout from './lk-admin/AdminLayout'
import SuccessPayment from '@app/modals/SuccessPayment.vue';

export default {
  name: 'app-cabinet',
  components: {
    SuccessPayment,
    WelcomeModal,
    'cabinet-admin': AdminLayout,
    'cabinet-client': ClientLayout,
    'cabinet-talent': TalentLayout,
  },
  computed: {
    ...mapState('currentUser', ['currentUser']),
  },
  methods: {
    ...mapActions('currentUser', ['currentUserAPI']),
  },
  data() {
    return {
      role: window.ROLE,
      BOT_LINK: window.BOT_LINK,
    }
  },
  async mounted() {
    await this.currentUserAPI()
    const isSubscription = this.currentUser.hasSubscription
    const isSubscriptionShow = localStorage.getItem('subscriptionShow');

    if (!isSubscription && !isSubscriptionShow && 'talent' === this.role) {
      this.$modal.show(
        SubscriptionPay,
        { info: this.$attrs },
        { },
        {
          closed: () => {
            const isModalShow = sessionStorage.getItem('modalShow')
            if (!isModalShow && this.BOT_LINK && 'admin' !== this.role) {
              this.$modal.show(ChatBotModal, { info: this.$attrs }, { classes: ['vm--modal_md'] })
            }
          },
        }
      )
    } else {
      const isModalShow = sessionStorage.getItem('modalShow')
      if (!isModalShow && this.BOT_LINK && 'admin' !== this.role) {
        this.$modal.show(ChatBotModal, { info: this.$attrs }, { classes: ['vm--modal_md'] })
      }
    }
  },
}
</script>
